import { ActionTypes } from "../constants/actionTypes";
import { apiService } from "../../services/apiServices";
import _ from "lodash";

export const getTourDetails = (
  authParams,
  history,
  handleError,
  handleFinish,
  isRider = false
) => {
  return (dispatch) => {
    apiService
      .getTourDetail(authParams)
      .then((response) => {
        const { data } = response;

        if (isRider && (!data?.tours || data?.tours?.length === 0)) {
          handleError({ data: "No tour found" });
        }

        dispatch({
          type: ActionTypes.GET_TOUR_DETAILS,
          payload: data?.tours || [],
        });
        if (handleFinish) {
          handleFinish({ status: "success", response: data?.paginationInfo });
        }
      })
      .catch(({ response = {} }) => {
        if (handleFinish) {
          handleFinish({ status: "failure" });
        }
        const { data = "Network Error!", status } = response;
        if (status === 401) return history("/unauthorized");
        handleError({ data });
      });
  };
};

export const getTourDetail = (
  authParams,
  history,
  handleError,
  handleFinish
) => {
  return (dispatch) => {
    apiService
      .getTour(authParams)
      .then((response) => {
        const { data } = response;

        if (_.isEmpty(data)) {
          handleError({ data: "No tour found" });
        }

        dispatch({
          type: ActionTypes.GET_TOUR_DETAILS,
          payload: [data],
        });
        if (handleFinish) {
          handleFinish({ status: "success", response: data?.paginationInfo });
        }
      })
      .catch(({ response = {} }) => {
        if (handleFinish) {
          handleFinish({ status: "failure" });
        }
        const { data = "Network Error!", status } = response;
        if (status === 401) return history("/unauthorized");
        handleError({ data });
      });
  };
};

export const getRiderList = (
  authParams,
  history,
  handleError,
  handleFinish
) => {
  return (dispatch) => {
    apiService
      .getUserDetail(authParams)
      .then((response) => {
        const { data } = response;

        if (!data || data?.length === 0) {
          handleError({ data: "No Rider found" });
        }
        const riders = data.map((rider, _index) => rider.userId);
        dispatch({
          type: ActionTypes.GET_RIDER_DETAILS,
          payload: riders,
        });

        if (handleFinish) {
          handleFinish({ status: "success", response: data?.paginationInfo });
        }
      })
      .catch(({ response = {} }) => {
        if (handleFinish) {
          handleFinish({ status: "failure" });
        }
        const { data = "Network Error!", status } = response;
        if (status === 401) return history("/unauthorized");
        handleError({ data });
      });
  };
};

export const getTourSealNumber = (
  authParams,
  isRider,
  history,
  handleError,
  handleFinish
) => {
  return (dispatch) => {
    apiService
      .getTourSealNumber(authParams, isRider)
      .then((response) => {
        const { data } = response;
        if (handleFinish) {
          handleFinish({ status: "success" });
        }
        let tourSealNumber = {};
        if (data?.result?.resultBody) {
          tourSealNumber = data?.result?.resultBody;
        }
        if (_.isEmpty(tourSealNumber) && isRider) {
          handleError({ data: "No seal number found for the tour." });
        }

        dispatch({
          type: ActionTypes.GET_TOUR_SEAL_DETAILS,
          payload: tourSealNumber,
        });
      })
      .catch(({ response = {} }) => {
        if (handleFinish) {
          handleFinish({ status: "failure" });
        }
        const { data = "Network Error!", status } = response;
        if (status === 401) return history("/unauthorized");
        handleError({ data });
      });
  };
};

export const clearTourDetails = () => {
  return (dispatch) => {
    dispatch({ type: ActionTypes.CLEAR_TOURS });
  };
};

export const clearRiderDetails = () => {
  return (dispatch) => {
    dispatch({ type: ActionTypes.CLEAR_RIDER_DETAILS });
  };
};

export const clearTourSealNumberDetails = () => {
  return (dispatch) => {
    dispatch({ type: ActionTypes.CLEAR_TOUR_SEAL_DETAILS });
  };
};
